<div class="overflow-hidden rounded-xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/3">
    <!-- Header -->
    <div
        class="flex flex-col justify-between gap-5 border-b border-gray-200 px-5 py-4 sm:flex-row sm:items-center dark:border-gray-800">
        <div>
            <h3 class="text-lg font-semibold text-gray-800 dark:text-white/90">Lista de usuarios</h3>
            <p class="text-sm text-gray-500 dark:text-gray-400">Administrar usuarios de la comunidad</p>
        </div>

    </div>

    <!-- Search and Filter -->
    <div class="border-b border-gray-200 px-5 py-4 dark:border-gray-800">
        <div class="flex gap-3 sm:justify-between">
            <div class="relative flex-1 sm:flex-auto">
                <span class="absolute top-1/2 left-4 -translate-y-1/2 text-gray-500 dark:text-gray-400">
                    <lib-icon name="search" class="text-md"></lib-icon>
                </span>

                <input type="text" [value]="searchTerm" (input)="onSearchInput($any($event.target).value)"
                    placeholder="Buscar usuario o email"
                    class="shadow-sm focus:border-brand-300 focus:ring-brand-500/10 dark:focus:border-brand-800 h-11 w-full rounded-lg border border-gray-300 bg-transparent py-2.5 pr-4 pl-11 text-sm text-gray-800 placeholder:text-gray-400 focus:ring-3 focus:outline-none sm:w-[360px] sm:min-w-[360px] dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30" />
            </div>
        </div>
    </div>

    <!-- Table -->
    <div class="overflow-x-auto custom-scrollbar">
        <table class="w-full">
            <thead>
                <tr class="border-b border-gray-200 dark:divide-gray-800 dark:border-gray-800">
                    <th (click)="onSortClick('NAME')"
                        class="cursor-pointer px-5 whitespace-nowrap py-4 text-left text-xs font-medium text-gray-500 dark:text-gray-400">
                        <div class="flex items-center gap-3">
                            <p class="text-xs font-medium text-gray-500 dark:text-gray-400">Usuario</p>
                            <span class="flex flex-col gap-0.5">
                                <lib-icon [ngClass]="sortIconClass('NAME', true)" name="table-sort-up"
                                    class="text-md"></lib-icon>
                                <lib-icon [ngClass]="sortIconClass('NAME', false)" name="table-sort-down"
                                    class="text-md"></lib-icon>
                            </span>
                        </div>
                    </th>

                    <th (click)="onSortClick('EMAIL')"
                        class="cursor-pointer px-5 py-4 whitespace-nowrap text-left text-xs font-medium text-gray-500 dark:text-gray-400">
                        <div class="flex items-center gap-3">
                            <p class="text-xs font-medium text-gray-500 dark:text-gray-400">Email</p>
                            <span class="flex flex-col gap-0.5">
                                <lib-icon [ngClass]="sortIconClass('EMAIL', true)" name="table-sort-up"
                                    class="text-md"></lib-icon>
                                <lib-icon [ngClass]="sortIconClass('EMAIL', false)" name="table-sort-down"
                                    class="text-md"></lib-icon>
                            </span>
                        </div>
                    </th>

                    <th
                        class="cursor-pointer px-5 py-4 whitespace-nowrap text-left text-xs font-medium text-gray-500 dark:text-gray-400">
                        <div class="flex items-center gap-3">
                            <p class="text-xs font-medium text-gray-500 dark:text-gray-400">Rol</p>
                        </div>
                    </th>

                    <th
                        class="cursor-pointer px-5 py-4 whitespace-nowrap text-left text-xs font-medium text-gray-500 dark:text-gray-400">
                        <div class="flex items-center gap-3">
                            <p class="text-xs font-medium text-gray-500 dark:text-gray-400">Estado online</p>
                        </div>
                    </th>

                    <th (click)="onSortClick('CREATED_AT')"
                        class="cursor-pointer px-5 whitespace-nowrap py-4 text-left text-xs font-medium text-gray-500 dark:text-gray-400">
                        <div class="flex items-center gap-3">
                            <p class="text-xs font-medium text-gray-500 dark:text-gray-400">Fecha creacion</p>
                            <span class="flex flex-col gap-0.5">
                                <lib-icon [ngClass]="sortIconClass('CREATED_AT', true)" name="table-sort-up"
                                    class="text-md"></lib-icon>
                                <lib-icon [ngClass]="sortIconClass('CREATED_AT', false)" name="table-sort-down"
                                    class="text-md"></lib-icon>                               
                            </span>
                        </div>
                    </th>

                </tr>
            </thead>

            <tbody class="divide-x divide-y divide-gray-200 dark:divide-gray-800">
                @if (loaded()) {
                    @if (loadedWithError()) {
                        <div class="p-5">
                          <span class="text-sm font-medium text-gray-700 dark:text-gray-200">Error cargando usuarios</span>
                        </div>
                    } @else {                    
                        @for (user of users(); track user.id) {
                            <tr class="transition hover:bg-gray-50 dark:hover:bg-gray-900">
                                <!-- User: icon + name -->                        
                                <td class="px-5 py-4 whitespace-nowrap">
                                    <div class="flex items-center gap-3">
                                        <div class="flex flex-col">
                                            <span class="text-sm font-medium text-gray-700 dark:text-gray-200">{{ user.name }}</span>
                                        </div>
                                    </div>
                                </td>

                                <!-- Email -->
                                <td class="px-5 py-4 whitespace-nowrap">
                                    <p class="text-sm text-gray-500 dark:text-gray-400">{{ user.email }}</p>
                                </td>

                                <!-- Role badge -->
                                <td class="px-5 py-4 whitespace-nowrap">
                                    <span class="text-xs rounded-full px-2 py-0.5 font-medium" [ngClass]="getRoleBadgeClass(user.role)">
                                        {{ roleLabel(user.role) }}
                                    </span>

                                </td>

                                <!-- Status badge -->
                                <td class="px-5 py-4 whitespace-nowrap">
                                    @if (user.role !== userRoles.INTERNAL) {
                                        <span class="text-xs rounded-full px-2 py-0.5 font-medium" [ngClass]="getStatusBadgeClass(user.status)">
                                            {{ statusLabel(user.status) }}
                                        </span>
                                        @if (user.isEmailValid !== null && !user.isEmailValid && user.status ===  userStatus.ACTIVE) {
                                            <span class="ml-2 text-xs rounded-full px-2 py-0.5 font-medium" [ngClass]="getIsEmailValidBadgeClass()">
                                                Correo no verificado
                                            </span>
                                        }
                                    }
                                </td>

                                <!-- CreatedAt -->
                                <td class="px-5 py-4">
                                    <p class="text-sm">
                                        <span class="text-gray-700 dark:text-gray-300">{{ (user.createdAt + 'Z') | date:'dd/MM/yyyy' }}</span>
                                        <span class="ml-2 text-gray-400 dark:text-gray-500">{{ (user.createdAt + 'Z') | date:'HH:mm' }}</span>
                                    </p>
                                </td>

                                <!-- Action -->
                                <td class="px-5 py-4 whitespace-nowrap">
                                    <button type="button" (click)="viewUser(user)" class="text-gray-400 hover:text-gray-700 dark:hover:text-gray-300">
                                        <lib-icon name="edit" class="text-md"></lib-icon>
                                    </button>
                                </td>
                            </tr>
                        }
                    }
                } @else {
                    <!-- Skeletons -->
                    @for (_ of [].constructor(pageSize); track $index) {
                        <tr>
                            <!-- Nom -->
                            <td class="px-3 py-4"><div class="animate-pulse rounded-full bg-gray-300 w-2/3 h-4 my-1"></div></td>
                            <!-- Email -->
                            <td class="px-3 py-4"><div class="animate-pulse rounded-2xl bg-gray-300 w-2/3 h-4 my-1"></div></td>
                            <!-- Rol -->
                            <td class="px-3 py-4"><div class="animate-pulse rounded-2xl bg-gray-300 w-1/2 h-4 my-1"></div></td>
                            <!-- Estatus -->
                            <td class="px-3 py-4"><div class="animate-pulse rounded-2xl bg-gray-300 w-1/2 h-4 my-1"></div></td>
                            <!-- Data creació -->
                            <td class="px-3 py-4"><div class="animate-pulse rounded-2xl bg-gray-300 w-1/2 h-4 my-1"></div></td>
                        </tr>
                    }
                }
            </tbody>
        </table>
    </div>

    <div
        class="flex items-center flex-col sm:flex-row justify-between border-t border-gray-200 px-5 py-4 dark:border-gray-800">
        <lib-pagination [totalPages]="totalPages" [initialPage]="currentPage" (pageChange)="onPageChange($event)"></lib-pagination>
    </div>
</div>